export function getImportableUrlFromAutomergeUrl(automergeUrl, subpath) {
    const base = `/${encodeURIComponent(automergeUrl)}/`;
    if (!subpath || subpath === ".")
        return base;
    // Strip leading "./" if present
    const clean = subpath.replace(/^\.\//, "");
    return `${base}${clean}`;
}
export function getImportableUrlFromDocHandle(handle, subpath) {
    return getImportableUrlFromAutomergeUrl(handle.url, subpath);
}
/** @deprecated Use {@link getImportableUrlFromAutomergeUrl} instead */
export function automergeUrlToServiceWorkerUrl(automergeUrl, subpath) {
    return getImportableUrlFromAutomergeUrl(automergeUrl, subpath);
}
/** @deprecated Use {@link getImportableUrlFromDocHandle} instead */
export function docHandleToServiceWorkerUrl(handle, subpath) {
    return getImportableUrlFromAutomergeUrl(handle.url, subpath);
}
